import _merge from 'lodash/merge';
import moment from 'moment';

import ConfigPresets from './presets';

export default class ConfigHelper {
    static title(text) {
        return {
            title: {
                text
            }
        };
    }

    static asyncDataLoading(navigatorData, callback) {
        return {
            navigator: {
                adaptToUpdatedData: false,
                series: {
                    data: navigatorData
                }
            },
            scrollbar: {
                liveRedraw: false
            },
            xAxis: {
                events: {
                    afterSetExtremes: callback
                },
                minRange: 3600
            }
        };
    }

    static merged(...configs) {
        return _merge(
            {},
            ConfigPresets.Base,
            ...configs
        );
    }

    static temperaturePreview({ average }, config = {}) {
        return ConfigHelper.merged(
            ConfigPresets.Temperature,
            ConfigPresets.Preview,
            ConfigPresets.TemperaturePreview,
            {
                series: [{
                    data: average,
                    name: 'Temperature',
                    zIndex: 1
                }]
            },
            config
        );
    }

    static temperatureFull({ average, ranges }, config = {}) {
        return ConfigHelper.merged(
            ConfigPresets.Temperature,
            ConfigPresets.Full,
            ConfigPresets.TemperatureFull,
            ConfigHelper.title('Average temperature with highs and lows'),
            {
                series: [{
                    data: average,
                    name: 'Temperature',
                    zIndex: 1
                }, {
                    data: ranges,
                    name: 'Temperature Range',
                    type: 'arearange',
                    linkedTo: ':previous'
                }]
            },
            config
        );
    }

    static touchPreview(data, config = {}) {
        return ConfigHelper.merged(
            ConfigPresets.Touch,
            ConfigPresets.Preview,
            ConfigPresets.TouchPreview,
            {
                series: [{
                    type: 'scatter',
                    name: 'Touch Count',
                    marker: {
                        radius: 6
                    },
                    data
                }]
            },
            config
        );
    }

    static touchFull(data, config = {}) {
        return ConfigHelper.merged(
            ConfigPresets.Touch,
            ConfigPresets.Full,
            ConfigPresets.TouchFull,
            ConfigHelper.title('Button presses'),
            {
                yAxis: {
                    title: {
                        text: 'Quantity'
                    },
                    tickInterval: 1
                },
                series: [{
                    type: 'scatter',
                    name: 'Touch Count',
                    marker: {
                        radius: 6
                    },
                    data
                }]
            },
            config
        );
    }

    static proximityPreview(data, config = {}) {
        return ConfigHelper.merged(
            ConfigPresets.Proximity,
            ConfigPresets.Preview,
            ConfigPresets.ProximityPreview,
            {
                series: [{
                    name: 'Proximity Status',
                    data
                }]
            },
            config
        );
    }

    static proximityFull(data, config = {}) {
        return ConfigHelper.merged(
            ConfigPresets.Proximity,
            ConfigPresets.Full,
            ConfigPresets.ProximityFull,
            ConfigHelper.title('Proximity Status'),
            {
                series: [{
                    name: 'Proximity Status',
                    data
                }]
            },
            config
        );
    }

    static getDefaultTimespan() {
        return {
            start: moment().subtract(1, 'day'),
            end: moment(),
            interval: '30m'
        };
    }
}



// WEBPACK FOOTER //
// ./app/services/charting/config-helper.js